import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Copy, Check, Users, DollarSign } from 'lucide-react';

const MyTransactions = () => {
  const { user } = useAuth();
  const transactions = user?.transactions || [];

  return (
    <div>
      <h1 className="text-2xl lg:text-3xl font-bold text-yellow-400 mb-6">My Transactions</h1>
      <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-[#1a2333]">
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">TX ID</th>
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">Type</th>
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">Amount</th>
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">Status</th>
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">Date</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length === 0 ? (
                <tr><td colSpan={5} className="px-6 py-12 text-center text-gray-500">No transactions found.</td></tr>
              ) : (
                transactions.map(tx => (
                  <tr key={tx.id} className="border-b border-[#1a2333] hover:bg-[#1a2333]/50 transition-colors">
                    <td className="px-6 py-4 text-white text-sm font-mono">#{tx.id.slice(-6)}</td>
                    <td className="px-6 py-4 text-white text-sm">{tx.type || 'Purchase'}</td>
                    <td className="px-6 py-4 text-white text-sm">{tx.amount} MRS</td>
                    <td className="px-6 py-4"><span className="text-xs font-bold px-2.5 py-1 rounded-full bg-yellow-400/10 text-yellow-400">{tx.status || 'Pending'}</span></td>
                    <td className="px-6 py-4 text-gray-400 text-sm">{new Date(tx.date).toLocaleDateString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export const MyReferrals = () => {
  const { user } = useAuth();
  const [copied, setCopied] = React.useState(false);
  const referralLink = `https://marsupilami.coin/ref/${user?.referralCode || 'XXXX'}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <h1 className="text-2xl lg:text-3xl font-bold text-yellow-400 mb-6">My Referrals</h1>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl p-5">
          <div className="flex items-center gap-2 mb-3">
            <Users size={18} className="text-purple-400" />
            <span className="text-gray-400 text-sm">Total Referrals</span>
          </div>
          <p className="text-white text-3xl font-bold">{user?.referrals || 0}</p>
        </div>
        <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl p-5">
          <div className="flex items-center gap-2 mb-3">
            <DollarSign size={18} className="text-green-400" />
            <span className="text-gray-400 text-sm">Total Earnings</span>
          </div>
          <p className="text-white text-3xl font-bold">${user?.earnings || 0}</p>
        </div>
        <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl p-5">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-gray-400 text-sm">Commission Rate</span>
          </div>
          <p className="text-yellow-400 text-3xl font-bold">5%</p>
        </div>
      </div>

      {/* Referral Link */}
      <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl p-6 mb-6">
        <h2 className="text-white font-bold text-lg mb-4">Your Referral Link</h2>
        <p className="text-gray-400 text-sm mb-4">Share this link with your friends and earn 5% commission on every purchase they make.</p>
        <div className="flex items-center gap-3">
          <div className="flex-1 bg-[#1a2333] border border-[#2a3a4a] rounded-lg px-4 py-2.5 text-yellow-400 text-sm font-mono truncate">{referralLink}</div>
          <button onClick={handleCopy} className="flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 rounded-lg px-4 py-2.5 text-yellow-400 hover:bg-yellow-400/20 transition-colors text-sm flex-shrink-0">
            {copied ? <Check size={16} /> : <Copy size={16} />}
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
      </div>

      {/* Referral History */}
      <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl overflow-hidden">
        <div className="px-6 py-4 border-b border-[#1a2333]">
          <h2 className="text-white font-bold">Referral History</h2>
        </div>
        <div className="p-6 text-center text-gray-500">No referrals yet. Share your link to start earning!</div>
      </div>
    </div>
  );
};

export default MyTransactions;
